import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { AssignmentPeriod } from "../assignmentPeriod/type";
import { PagedResponse } from "../../types/Result";

export const assignmentPeriodListLoader: LoaderFunction = async (args) => {
  let url = new URL(args.request.url);
  const result = await axiosApi.get<PagedResponse<AssignmentPeriod>>(
    url.search
      ? `/api/assignmentPeriods${url.search}`
      : "/api/assignmentPeriods?sort.field=year&sort.sort=desc&pageNumber=1&pageSize=10",
  );

  return result.data;
};
